import React, { useEffect, useRef, useState } from 'react';
import { Card, Label, Tabs, TabsRef } from 'flowbite-react';

import AvailabilitiesByDateTable from './AvailabilitiesByDateTable';
import MentorAvailabilitiesInput from './MentorAvailabilitiesInput';
import { UserAvailabilityInput } from 'types';
import dayjs from 'dayjs';

type Props = {
	availabilities: UserAvailabilityInput[];
	setAvailabilities?: React.Dispatch<React.SetStateAction<UserAvailabilityInput[]>>;
	allowUpdate?: Boolean;
};

type PastActiveType = {
	past: UserAvailabilityInput[];
	active: UserAvailabilityInput[];
};
const MentorAvailabilityDetails = ({ availabilities, setAvailabilities, allowUpdate = false }: Props) => {
	const tabsRef = useRef<TabsRef>(null);
	const [activeTab, setActiveTab] = useState<number>(allowUpdate ? 1 : 2);
	const [pastAvailabilities, setPastAvailabilities] = useState<UserAvailabilityInput[]>([]);
	const [activeAvailabilities, setActiveAvailabilities] = useState<UserAvailabilityInput[]>([]);

	useEffect(() => {
		if (availabilities) {
			const currentMoment = dayjs();
			let byDateAvailabilities = availabilities?.reduce(
				(acc: PastActiveType, crr) => {
					// let date = moment(crr.startTime);

					if (currentMoment.isAfter(crr.startTime)) {
						acc.past.push(crr);
					} else {
						acc.active.push(crr);
					}
					return acc;
				},
				{ past: [], active: [] },
			);

			setActiveAvailabilities(byDateAvailabilities.active);
			setPastAvailabilities(byDateAvailabilities.past);
		}
	}, [availabilities]);

	return (
		<Card>
			<div>
				<Label>{'User Availability '}</Label>
				<span className="text-[red]">*</span>
			</div>
			<Tabs.Group
				className="p-2 pb-0"
				aria-label="Availability Details"
				// style="underline"
				ref={tabsRef}
				onActiveTabChange={tab => setActiveTab(tab)}
			>
				<Tabs.Item
					title={<div className="px-2 flex gap-2 justify-center items-center">Past Slots</div>}
					active={activeTab === 0}
					disabled={pastAvailabilities.length === 0}
				>
					<AvailabilitiesByDateTable availabilities={pastAvailabilities} />
				</Tabs.Item>
				<Tabs.Item
					title={
						<div className="px-2 flex gap-2 justify-center items-center">
							{availabilities.length === 0 ? 'Add' : 'Update'} Slots
						</div>
					}
					active={activeTab === 1}
					disabled={!allowUpdate}
				>
					<MentorAvailabilitiesInput availabilities={availabilities} setAvailabilities={setAvailabilities} />
				</Tabs.Item>
				<Tabs.Item
					title={<div className="px-2 flex gap-2 justify-center items-center">Review Availability</div>}
					active={activeTab === 2}
					disabled={activeAvailabilities.length === 0}
				>
					<AvailabilitiesByDateTable availabilities={activeAvailabilities} />
				</Tabs.Item>
			</Tabs.Group>
		</Card>
	);
};

export default MentorAvailabilityDetails;
